export interface MissingTranslationRequest {
  translationKey: string;
  language: string;
  translationGroup: string;
  translationSubGroup: string;
  translatedValue: string;
}

export class MissingTranslationLog implements MissingTranslationRequest {
  translationKey: string;
  language: string;
  translationGroup: string;
  translationSubGroup: string;
  translatedValue: string;

  constructor(values: MissingTranslationRequest) {
    Object.assign(this, values);
  }
}